import { SVGProps } from "react";

const PDF = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={29.528}
    height={40.001}
    viewBox="0 0 30 41"
    {...props}
  >
    <g data-name="Group 12637">
      <path
        fill="#ff1f25"
        d="M29.528 11.851v22.817A5.334 5.334 0 0 1 24.194 40H5.333A5.333 5.333 0 0 1 0 34.668V5.334A5.334 5.334 0 0 1 5.333 0h12.344Z"
        data-name="Path 24098"
      />
      <path fill="#ff676b" d="M29.529 11.9h-11.9V0Z" data-name="Path 24099" />
      <path
        fill="#fff"
        d="M5.177 22.71a14.224 14.224 0 0 1 2.347-.159 3.685 3.685 0 0 1 2.347.615 2.246 2.246 0 0 1 .82 1.778 2.454 2.454 0 0 1-.706 1.823 3.561 3.561 0 0 1-2.5.809 4.375 4.375 0 0 1-.593-.034v2.746H5.177Zm1.725 3.49a2.658 2.658 0 0 0 .581.046c.923 0 1.493-.467 1.493-1.254 0-.706-.49-1.128-1.356-1.128a2.957 2.957 0 0 0-.718.068Z"
        data-name="Path 24100"
      />
      <path
        fill="#fff"
        d="M11.76 22.711a15.5 15.5 0 0 1 2.347-.16 4.941 4.941 0 0 1 3.145.82 3.4 3.4 0 0 1 1.3 2.894 3.9 3.9 0 0 1-1.276 3.111 5.514 5.514 0 0 1-3.544.991 15.055 15.055 0 0 1-1.971-.114Zm1.743 6.267a3.2 3.2 0 0 0 .6.034 2.381 2.381 0 0 0 2.6-2.689 2.2 2.2 0 0 0-2.416-2.439 3.616 3.616 0 0 0-.786.068Z"
        data-name="Path 24101"
      />
      <path
        fill="#fff"
        d="M19.655 22.607h4.695v1.424h-2.951v1.755h2.758v1.413h-2.758v3.088h-1.743Z"
        data-name="Path 24102"
      />
    </g>
  </svg>
);
export default PDF;
